import { SensorStrings } from "./api";

export type SensorLang = "en" | "es";

export function parseSensorLang(value: string | null | undefined): SensorLang {
    return value === "es" ? "es" : "en";
}

function detectStoredLang(): SensorLang {
    const stored = localStorage.getItem("locale");
    return stored?.toLowerCase().startsWith("es") ? "es" : "en";
}

function resolveLocaleKeys(lang?: SensorLang | null): string[] {
    const resolvedLang = lang ?? detectStoredLang();

    if (resolvedLang === "es") {
        return ["es-ES", "esES", "esEs", "enUs", "enUS", "en-US"];
    }
    return ["enUs", "enUS", "en-US"];
}

export function getSensorStrings(strings: SensorStrings, lang?: SensorLang | null): Record<string, string> {
    for (const key of resolveLocaleKeys(lang)) {
        if (strings[key]) {
            return strings[key];
        }
    }

    return { label: "Unknown" };
}
